import { Formik } from 'formik';
import * as Yup from 'yup';
import { useState } from 'react';
import Button from '../../../../../components/form-control/Button';
import TextArea from '../../../../../components/form/TextArea';

interface RejectLoanProps {
  onProceed: (reason: string) => void;
  onClose: () => void;
}

const RejectLoanModal = ({ onProceed, onClose }: RejectLoanProps) => {
  const [submitting, setSubmitting] = useState<boolean>(false);


  return (
    <>
      <div className="p-[1rem] w-full">
        <Formik
          initialValues={{
            reason: ''
          }}
          validateOnChange={false}
          validateOnBlur
          validationSchema={Yup.object({
            reason: Yup.string().trim().required('Reason is required.')
          })}
          onSubmit={(values) => {
            onProceed(values.reason);
          }}>
          {({ values, errors, handleSubmit, handleChange, setFieldValue, handleBlur, touched }) => (
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className="">
                <TextArea
                  name="reason"
                  id="reason"
                  label="Reasons for rejecting this loan."
                  rows={2}
                  className={"border border-gray-200 bg-transparent rounded-[0px] placeholder-[#848484] focus:ring-0 px-4 py-3 focus:outline-none resize-none"}
                  value={values?.reason ?? ''}
                  // onChange={() => { }}
                  onValueChanged={handleChange}
                  onFocusOut={handleChange}
                  error={touched?.reason ? errors.reason : undefined}
                  helperText={touched?.reason ? errors.reason : undefined}
                />
              </div>

              <div className="w-full flex gap-4 mt-6 !mb-4">
                <Button
                  type="button"
                  label="Cancel"
                  onClick={onClose}
                  bgColor='secondary'
                  fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
                <Button
                  label="Submit"
                  onClick={handleSubmit}
                  bgColor='primary'
                  fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
              </div>
            </form>
          )}
        </Formik>
      </div>
    </>
  );
};


export default RejectLoanModal;